function vLookup(lookupData) {  
  for (var i = 0; i < lookupData.dataArr.length; i++) {
    if (lookupData.dataArr[i].age > lookupData.age) {
      return lookupData.dataArr[i - 1].rate;
    }
  }
  return lookupData.dataArr[lookupData.dataArr.length - 1].rate;
}

function IPVlookup(params, vars) {
  const dataArr = vars['incomeProtection' + params.benefitPeriod][params.gender][params.waitingPeriod]
  for (var i = 0; i < dataArr.length; i++) {
    if (dataArr[i].age > params.age) {
      return dataArr[i - 1].rate;
    }
  }
  return dataArr[dataArr.length - 1].rate;
}

function roundHalfUp2(number) {
  return Number(Math.round(number+'e'+2)+'e-'+2).toFixed(2);
}

function calculatedPremium(monthly, period) {
  const premium = period == 'week' ? monthly * 12 / 52 : period == 'year' ? monthly * 12 : monthly;
  return (premium > 0 ? Math.max(premium, 0.01) : premium).toFixed(2);
}

export function benefitPeriodElegibility65() {
  return true
}

export function benefitPeriodElegibility5() {
  return true
}

export function calculate(state, context) {
  const stepData = state.data.stepData;
  const premiumVariables = state.premiumVariables;

  const deathOnlyUnitVLookupData = {
    gender: stepData.gender,
    age: stepData.age,
    dataArr: premiumVariables.deathTPD.deathOnlyUnits,
  }
  context.deathOnlyUnitSize = vLookup(deathOnlyUnitVLookupData);
  
  const TPDUnitVLookupData = {
    gender: stepData.gender,
    age: stepData.age,
    dataArr: premiumVariables.deathTPD.TPDUnits,
  }
  context.TPDUnitSize = vLookup(TPDUnitVLookupData);

  if(context.isValid) {
    if(context.deathTPDmetric == 'fixed') {
      context.deathOnlyCoverAmount = Math.ceil(context.deathOnlyCoverAmount/1)*1;
      context.TPDCoverAmount = Math.ceil(context.TPDCoverAmount/1)*1;
    }

    const deathOnlyLookupData = {
      gender: stepData.gender, age: stepData.age,
      dataArr: premiumVariables.deathTPD.deathOnlyPremium[stepData.gender],
    }
    const deathOnlyRate = vLookup(deathOnlyLookupData);

    const TPDLookupData = {
      gender: stepData.gender, age: stepData.age,
      dataArr: premiumVariables.deathTPD.TPDPremium[stepData.gender],
    }
    const TPDRate = vLookup(TPDLookupData);

    const occ = stepData.occupation.toLowerCase().split(" ")[0];
    const occupationFactor = premiumVariables.occupationalFactors[occ];

    const deathOnlyOccupationFactor = occupationFactor.deathOnly;
    const TPDOccupationFactor = occupationFactor.TPD;
    const IPOccupationFactor = occupationFactor.incomeProtection;

    context.unitsDeathOnly = Math.ceil(context.deathOnlyCoverAmount / context.deathOnlyUnitSize);
    let roundedDeathOnlyCoverAmount = context.unitsDeathOnly * context.deathOnlyUnitSize;

    context.unitsTPD = Math.min(Math.ceil(context.TPDCoverAmount / context.TPDUnitSize), stepData.TPDMaxUnits);
    let roundedTPDCoverAmount = context.unitsTPD * context.TPDUnitSize;

    if(context.deathTPDmetric == 'units') {
      context.deathOnlyCoverAmount = roundedDeathOnlyCoverAmount;
      context.TPDCoverAmount = roundedTPDCoverAmount;
    }

    const deathWithoutTPDCoverAmount = Math.max(context.deathOnlyCoverAmount - context.TPDCoverAmount, 0);
    const deathWithTPDCoverAmount = context.deathOnlyCoverAmount - deathWithoutTPDCoverAmount;
    const deathFactored = deathWithoutTPDCoverAmount * deathOnlyOccupationFactor;
    const deathWithTPDFactored = deathWithTPDCoverAmount * TPDOccupationFactor;

    context.dollarAmountDeathOnly = roundHalfUp2((deathFactored + deathWithTPDFactored)/1000 * (deathOnlyRate/12).toFixed(8));
    context.dollarAmountTPD = roundHalfUp2(context.TPDCoverAmount/1000 * (TPDRate/12).toFixed(8) * TPDOccupationFactor);

    if(context.deathTPDmetric == 'units') {
      context.unitsAmountDeathOnly = context.dollarAmountDeathOnly;
      context.unitsAmountTPD = context.dollarAmountTPD;
    } else {
      const roundedDeathWithoutTPDCoverAmount = Math.max(roundedDeathOnlyCoverAmount - roundedTPDCoverAmount, 0);
      const roundedDeathWithTPDCoverAmount = roundedDeathOnlyCoverAmount - roundedDeathWithoutTPDCoverAmount;
      const roundedDeathFactored = roundedDeathWithoutTPDCoverAmount * deathOnlyOccupationFactor;
      const roundedDeathWithTPDFactored = roundedDeathWithTPDCoverAmount * TPDOccupationFactor;

      context.unitsAmountDeathOnly = roundHalfUp2((roundedDeathFactored + roundedDeathWithTPDFactored)/1000 * (deathOnlyRate/12).toFixed(8));
      context.unitsAmountTPD = roundHalfUp2(roundedTPDCoverAmount/1000 * (TPDRate/12).toFixed(8) * TPDOccupationFactor);
    }

    if (stepData.age > stepData.IPMaxAge) {
      context.disableIPInputBasedOnAge = true;
      context.unitsAmountIP = 0.00;
      context.unitsIP = 0;
      context.IPCoverAmount = 0;
      context.benefitPeriod = null;
      context.waitingPeriod = null;
    } else {
      const IPlookupData = {
        benefitPeriod: context.benefitPeriod,
        waitingPeriod: 'waitingPeriod' + context.waitingPeriod,
        gender: stepData.gender, age: stepData.age
      }
      const IPVLookupRate = IPVlookup(IPlookupData, state.premiumVariables);

      if(stepData.IPmetricFixed) {
        context.IPCoverAmount = Math.min(context.IPCoverAmount, context.IPCoverMax);
        context.unitsAmountIP = roundHalfUp2(context.IPCoverAmount/1000 * (IPVLookupRate/12).toFixed(8) * IPOccupationFactor);
      } else {
        const maxUnitsIP = Math.floor(context.IPCoverMax / context.IPUnitSize);
        context.unitsIP = Math.min(Math.ceil(context.IPCoverAmount / context.IPUnitSize), maxUnitsIP);
        context.IPCoverAmount = context.unitsIP * context.IPUnitSize;
        context.unitsAmountIP = roundHalfUp2(IPVLookupRate * (context.unitsIP/12).toFixed(8) * IPOccupationFactor);
      }
    }

    const deathOnlyTotal = parseFloat(context.dollarAmountDeathOnly);
    const TPDMetricTotal = parseFloat(context.dollarAmountTPD);
    const IncomeProtectionTotal = parseFloat(context.unitsAmountIP);

    context.estimatedPremium = parseFloat(deathOnlyTotal + TPDMetricTotal + IncomeProtectionTotal);
    context.calculatedPremium = calculatedPremium(context.estimatedPremium, context.estimatedPremiumPeriod);

    return context;
  }
}
